import { render } from "./EventHome.vue?vue&type=template&id=99f8fd68&scoped=true"
import script from "./EventHome.vue?vue&type=script&lang=js"
export * from "./EventHome.vue?vue&type=script&lang=js"

import "./EventHome.vue?vue&type=style&index=0&id=99f8fd68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f8fd68"]])

export default __exports__